import React, { Component } from "react";
import { DKLabel, DKButton, DKIcons } from "deskera-ui-library";
import AutomationManager from "../AutomationManager";
import { AUTOMATION_TRIGGERS } from "../AutomationConstants";

/*
PROPS:
- onClose
- onSelect(triggerData)
*/

class AddTriggerPopup extends Component {
  popupTriggerChildData = [];
  constructor(props) {
    super(props);
    this.state = {
      showPopup:false
    };
  }
  render() {
    return (<>
      <div className="transparent-background">
        <div
          className="popup-window pt-s p-h-l row justify-content-center flex-wrap "
          style={{ backgroundColor: "rgb(245, 245, 245)" }}
        >
          {this.renderHeader()}
          {this.renderAllTriggers(AutomationManager.getAllTriggers())}
        </div>
      </div>
      {this.allTrigerPopup()}
      </>
    );
  }
  allTrigerPopup() {
    return (
      <>
        {(this.state.showPopup  ) && <div className="transparent-background">
          <div
            className="popup-window pt-s p-h-l"
            style={{ backgroundColor: "rgb(245, 245, 245)" }}
          >
            <div className="row justify-content-between pt-s pb-m">
              <DKLabel text="Choose datasource..." className="fw-m fs-l" />
              <DKButton icon={DKIcons.ic_close} onClick={() =>{
                this.popupTriggerChildData = []
                this.setState({ showPopup: false })
                }
              } />
            </div>
            {this.renderAllTriggers(this.popupTriggerChildData)}
          </div>
        </div>}
      </>
    )
  }

  renderHeader() {
    return (
      <div className="row justify-content-between pt-s pb-m">
        <DKLabel text="Start my workflow when..." className="fw-m fs-l" />
        <DKButton icon={DKIcons.ic_close} onClick={this.props.onClose} />
      </div>
    );
  }

  renderAllTriggers(allTriggers) {
    return (
      <div
        className="row justify-content-center flex-wrap mb-m"
        style={{ gap: 18 }}
      >
        {allTriggers?.map((trigger) => {
          return this.renderTriggerButton(trigger);
        })}
      </div>
    );
  }

  renderTriggerButton(triggerData) {
    return (
      <div
        className="row border-m bg-white border-radius-s shadow-s p-r  cursor-hand unselectable"
        style={{ width: "48%" }}
        onClick={()=>{
          if(triggerData&&triggerData.children){
            this.popupTriggerChildData = triggerData.children;
            this.setState({ showPopup: true})
          } else {
            this.popupTriggerChildData = []
            this.setState({ showPopup: false});
            if(this.props.onSelect) {
              this.props.onSelect(triggerData);
            }
          }
        }
        }
      >
        {AutomationManager.getTriggerIcon(triggerData.type)}
        <DKLabel text={triggerData.title} className="ml-m" />
      </div>
    );
  }
}

export default AddTriggerPopup;
